'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _dec3, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactSlidedown = require('react-slidedown');

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _ = require('../');

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _ScreenedCompanies = require('./ScreenedCompanies.css');

var _ScreenedCompanies2 = _interopRequireDefault(_ScreenedCompanies);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScreenedCompaniesTable = (_dec = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ScreenedCompaniesTable, _Component);

  function ScreenedCompaniesTable(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompaniesTable);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompaniesTable.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompaniesTable)).call(this, props));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(ScreenedCompaniesTable, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'table',
        { styleName: 't-table' },
        _react2.default.createElement(
          'thead',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'th',
              null,
              'Company'
            ),
            _react2.default.createElement(
              'th',
              null,
              'Symbol'
            )
          )
        ),
        _react2.default.createElement(
          'tbody',
          null,
          this.props.companies.map(function (c, i) {
            return _react2.default.createElement(
              'tr',
              { key: c.primary_symbol + '-' + i },
              _react2.default.createElement(
                'td',
                null,
                c.short_name
              ),
              _react2.default.createElement(
                'td',
                null,
                c.primary_symbol
              )
            );
          })
        )
      );
    }
  }]);
  return ScreenedCompaniesTable;
}(_react.Component), _class2.propTypes = {
  companies: _react.PropTypes.array.isRequired
}, _temp)) || _class);
var ScreenedCompanies = (_dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.company.result,
    searching: state.company.loading,
    searched: state.company.loaded,
    error: state.company.error
  };
}, searchActions), _dec3 = (0, _reactCssModules2.default)(_ScreenedCompanies2.default, { allowMultiple: true }), _dec2(_class3 = _dec3(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(ScreenedCompanies, _Component2);

  function ScreenedCompanies(props) {
    (0, _classCallCheck3.default)(this, ScreenedCompanies);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (ScreenedCompanies.__proto__ || (0, _getPrototypeOf2.default)(ScreenedCompanies)).call(this, props));

    _this2.state = {};
    return _this2;
  }

  (0, _createClass3.default)(ScreenedCompanies, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.props.companies();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      if (props.result) {
        var gmCompanies = [];
        var grCompanies = [];
        props.result.map(function (el) {
          if (el.is_gm) gmCompanies.push(el);
          if (el.is_gr) grCompanies.push(el);
          return false;
        });
        var _sorter = function _sorter(a, b) {
          var lbl = 'short_name';
          var a_s = a[lbl].toLowerCase();
          var b_s = b[lbl].toLowerCase();
          return a_s.localeCompare(b_s);
        };
        gmCompanies = gmCompanies.sort(_sorter);
        grCompanies = grCompanies.sort(_sorter);
        this.setState({
          gmCompanies: gmCompanies,
          grCompanies: grCompanies
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      if (!this.props.result || !this.state.gmCompanies || !this.state.grCompanies) {
        return _react2.default.createElement(
          'div',
          { styleName: 'main' },
          _react2.default.createElement(_reactLoader2.default, {
            options: { scale: 0.70, top: '4.0rem' },
            loaded: false
          })
        );
      }

      var icons = {
        gm: require('../../../static/images/icn-gm.svg'),
        gr: require('../../../static/images/icn-gr.svg')
      };

      return _react2.default.createElement(
        'div',
        { styleName: 'main-wrap' },
        _react2.default.createElement(
          'div',
          { styleName: 'screen-card' },
          _react2.default.createElement(
            'div',
            { styleName: 'screen-bullet' },
            _react2.default.createElement('img', {
              styleName: 'screen-icon',
              alt: 'Gun manufacturers',
              src: icons.gm
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'screen-icon-label' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'bold' },
                  'Gun manufacturers'
                ),
                ' \u2014 On an average day, 93 Americans are killed with guns. Over 90% of the country supports expanding background checks to all gun sales and the majority supports increased safety regulation, but many of these same people are invested their savings in firearm manufacturers and don\u2019t even know it. This list represents the leading public companies involved in manufacturing civilian firearms including handguns, rifles, and ammunition.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'The primary source data for these lists are exclusion screens from asset managers:',
                _react2.default.createElement(
                  'ul',
                  null,
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: 'https://iyv-charts.s3.us-west-2.amazonaws.com/exclusion-lists/NZ+Super+Fund+Exclusions+June+2022.xlsx',
                        title: 'NZ Super Fund Exclusions June 2022',
                        xstrong: true
                      },
                      'NZ Super Fund Exclusions June 2022 - Civilian automatic and semi-automatic firearms'
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _.Link,
                      {
                        to: 'https://iyv-charts.s3.us-west-2.amazonaws.com/exclusion-lists/Robeco+Institutional+Asset+Management+Exclusion+List+December+2022.pdf',
                        title: 'Robeco Institutional Asset Management Exclusions List December 2022',
                        xstrong: true
                      },
                      'Robeco Institutional Asset Management Exclusions List December 2022 - Firearms (Level 2 \u2018Exclusions+\u2019)'
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(ScreenedCompaniesTable, { companies: this.state.gmCompanies })
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'screen-card' },
          _react2.default.createElement(
            'div',
            { styleName: 'screen-bullet' },
            _react2.default.createElement('img', {
              styleName: 'screen-icon',
              alt: 'Major gun retailers',
              src: icons.gr
            }),
            _react2.default.createElement(
              'div',
              { styleName: 'screen-icon-label' },
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  { styleName: 'bold' },
                  'Major gun retailers'
                ),
                ' \u2014 Retailers selling handguns, shotguns, rifles, and ammunition \u2014 including high-capacity magazines and semiautomatic weapons known commonly as \u201Cassault rifles\u201D \u2014 are raking in billions in weapons sales. We don\u2019t need to finance violence in order to invest in our own retirement accounts. The gun retailers listed here represent the largest public companies that sell firearms or ammunition to the civilian market.'
              )
            )
          ),
          _react2.default.createElement(ScreenedCompaniesTable, { companies: this.state.grCompanies })
        )
      );
    }
  }]);
  return ScreenedCompanies;
}(_react.Component), _class4.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array
}, _temp2)) || _class3) || _class3);
exports.default = ScreenedCompanies;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ScreenedCompanies/ScreenedCompanies.js
// module id = 1281
// module chunks = 0